import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import Tabs from '@commons/tabs'
import SeoForm from './form'
const AdminSeoSettingsPage = () => {
  const tabs = [
    {
      title: 'Home',
      Component: SeoForm,
      key: 'home',
      props: {
        selector: 'homeSeo',
        id: 'home-seo',
        title: 'Home Seo',
      },
    },
    {
      title: 'About Us',
      Component: SeoForm,
      key: 'about-us',
      props: {
        selector: 'aboutSeo',
        id: 'about-seo',
        title: 'About Seo',
      },
    },
    {
      title: 'Service',
      Component: SeoForm,
      key: 'service',
      props: {
        selector: 'serviceSeo',
        id: 'service-seo',
        title: 'Service Seo',
      },
    },
    {
      title: 'Contact Us',
      Component: SeoForm,
      key: 'contact-us',
      props: {
        selector: 'contactSeo',
        id: 'contact-seo',
        title: 'Contact Seo',
      },
    },
    {
      title: 'Login',
      Component: SeoForm,
      key: 'login',
      props: {
        selector: 'loginSeo',
        id: 'login-seo',
        title: 'Login Seo',
      },
    },
    {
      title: 'Register',
      Component: SeoForm,
      key: 'register',
      props: {
        selector: 'RegisterSeo',
        id: 'register-seo',
        title: 'Register Seo',
      },
    },
  ]
  return (
    <Column>
      <Column styleColumn="margin-bottom:20px;">
        <SectionHeading title="Seo Settings" />
      </Column>
      <Tabs items={tabs} />
    </Column>
  )
}

export default AdminSeoSettingsPage
